// Single source of truth for the FMDO ads funnel (landing page + checkout).
// Ported from C:\FMDO index.html / plan.html where these were duplicated.

const A = "/fmdo"; // public asset base

export const ASSETS = {
  logoWhite: `${A}/logo-white.png`,
  heroVideo: `${A}/hero-video.mp4`,
  fuga: `${A}/fuga.svg`,
  umg: `${A}/umg.svg`,
};

export const WHATSAPP_URL = "https://wa.me/918512893854";
export const SIGNUP_URL = "https://app.fmdigitalofficial.com/sign-up";
export const META_PIXEL_ID = "1521047872348555";

// Starter-plan offer window (drives the countdown + ribbon)
export const OFFER_START = "2026-08-01T00:00:00";
export const OFFER_END = "2026-08-31T23:59:59";

export const STATS = [
  { count: 12, suffix: "k+", label: "Songs Distributed" },
  { count: 1, suffix: "k+", label: "Artists Served" },
  { count: 500, suffix: "+", label: "Labels Served" },
  { count: 1.2, suffix: "B", label: "Streams Till Now" },
];

export const WHY_CARDS = [
  { icon: "🌍", title: "Global Distribution", desc: "Deliver your releases to 190+ stores and streaming services across every major market." },
  { icon: "⚡", title: "Fast Approval", desc: "Quick reviews and standard delivery times so your music goes live without the wait." },
  { icon: "🎧", title: "Playlist Pitching", desc: "Get your tracks in front of editorial and curator playlists to reach new listeners." },
  { icon: "🤝", title: "Artist Support", desc: "A dedicated 24/7 support panel ready to help you at every step of your journey." },
  { icon: "🏷️", title: "Label Services", desc: "Manage multiple artists and catalogs with tools built for labels of every size." },
  { icon: "💰", title: "Revenue Management", desc: "Track royalties, publishing, and payouts with full transparency over your earnings." },
];

const dsp = (file, name) => ({ img: `${A}/dsps/${file}.svg`, name });

export const DSP_ROW_1 = [
  dsp("spotify", "Spotify"),
  dsp("apple-music", "Apple Music"),
  dsp("yt-music", "YT Music"),
  dsp("amazon-music", "Amazon Music"),
  dsp("tidal", "Tidal"),
  dsp("deezer", "Deezer"),
  dsp("jio-savan", "JioSaavn"),
  dsp("pandora", "Pandora"),
  dsp("soundcloud", "SoundCloud"),
  dsp("vevo", "Vevo"),
  dsp("shazam", "Shazam"),
  dsp("tiktok", "TikTok"),
  dsp("meta", "Meta"),
  dsp("snap", "Snapchat"),
];

export const DSP_ROW_2 = [
  dsp("boomplay", "Boomplay"),
  dsp("anghami", "Anghami"),
  dsp("beatport", "Beatport"),
  dsp("kkbox", "KKBOX"),
  dsp("audiomack", "Audiomack"),
  dsp("gaana", "Gaana"),
  dsp("triller", "Triller"),
  dsp("resso", "Resso"),
  dsp("qobuz", "Qobuz"),
  dsp("line-music", "Line Music"),
  dsp("tencent-music", "Tencent"),
  dsp("youtube", "YouTube"),
];

export const TESTIMONIALS = [
  {
    img: `${A}/testimonials/hosanna-ministries-official.png`,
    name: "Kalyan Babu",
    label: "Hosanna Ministries Official",
    type: "Label",
    years: "1 Year",
    bg: "radial-gradient(ellipse at 60% 30%,#0d3320 0%,#051409 55%,#030d06 100%)",
    color: "#4ade80",
    text: "My name is Kalyan Babu (Hosanna Ministries Official), and I have been working with FM Digital Official for the past 1 Year. My experience with their team has been truly amazing. They provide a smooth and hassle-free music distribution service with a highly professional, supportive, and polite team. FM Digital Official offers affordable plans that are perfect for independent artists and music labels, especially those who are just starting their journey in the music industry. I highly recommend FM Digital Official to anyone looking for a reliable and trusted music distribution partner.",
  },
  {
    img: `${A}/testimonials/ramesh-hosanna-ministries.png`,
    name: "Bhanu",
    label: "Ramesh Hosanna Ministries",
    type: "Label",
    years: "5 Years",
    bg: "radial-gradient(ellipse at 40% 30%,#1e0b38 0%,#0d0618 55%,#060310 100%)",
    color: "#a78bfa",
    text: "I am Bhanu (Ramesh Hosanna Ministries), and I have been working with FM Digital Official for 5 years. My journey with them has been very satisfying. The team is humble, supportive, and always ensures that the process is easy and transparent. Their budget-friendly plans and excellent service make FM Digital Official a perfect partner for emerging artists and new music labels.",
  },
  {
    img: `${A}/testimonials/hosanna-ministries-kurnool.png`,
    name: "Yamanni Arun",
    label: "Hosanna Ministries Kurnool",
    type: "Label",
    years: "5 Years",
    bg: "radial-gradient(ellipse at 55% 35%,#062428 0%,#031318 55%,#020a0c 100%)",
    color: "#22d3ee",
    text: "My name is Yamanni Arun (Hosanna Ministries Kurnool), and I have been a partner with FM Digital Official for 5 Years. I truly appreciate the professionalism and kindness of their team. They have made music distribution simple, efficient, and stress-free for us. I would recommend FM Digital Official to independent artists and labels who are looking for quality services at reasonable pricing.",
  },
  {
    img: `${A}/testimonials/rd-parmar.png`,
    name: "RD Parmar",
    label: "Sunday Fun Production",
    type: "Label",
    years: "4 Years",
    bg: "radial-gradient(ellipse at 45% 30%,#081430 0%,#040a1c 55%,#02050e 100%)",
    color: "#60a5fa",
    text: "I am RD Parmar (Sunday Fun Production), and I have been associated with FM Digital Official for 4 Years. Choosing them as our music distribution partner has been one of the best decisions for our music journey. The entire team is friendly and supportive, the process is seamless, and their affordable plans are especially beneficial for independent artists and upcoming labels.",
  },
  {
    img: `${A}/testimonials/ajay-salwan.png`,
    name: "Ajay Salwan",
    label: "Ajay Salwan",
    type: "Artist",
    years: "5 Years",
    bg: "radial-gradient(ellipse at 50% 30%,#2a1a05 0%,#180e02 55%,#0e0801 100%)",
    color: "#fbbf24",
    text: "My name is Ajay Salwan (Ajay Salwan), and I have been working with FM Digital Official for 5 Years. Their services have always been dependable and easy to use. The team is professional, cooperative, and treats every artist and label with great respect. For anyone starting their career in the music field, FM Digital Official offers the right combination of affordability, support, and reliable distribution.",
  },
  {
    img: `${A}/testimonials/bobby-karra.png`,
    name: "Bobby Karra",
    label: "Bobby Karra",
    type: "Label",
    years: "2 Years",
    bg: "radial-gradient(ellipse at 55% 30%,#280810 0%,#180408 55%,#0e0205 100%)",
    color: "#fb7185",
    text: "I am Bobby Karra, and my association with FM Digital Official has been for 2 Years. It has been a smooth and positive experience from the beginning. The team is very polite, responsive, and always ready to provide support. With their affordable plans and artist-friendly approach, FM Digital Official is a great platform for new talents and growing music labels.",
  },
];

export const FAQS = [
  {
    q: "Which streaming services do you distribute to?",
    a: "We distribute to all the major streaming services: Spotify, Apple Music, TikTok, YouTube, Deezer, Tidal, and over 200 other streaming platforms and stores globally.",
  },
  {
    q: "How do you distribute my music for free?",
    a: 'FM Digital Official offers free distribution through a process called "royalty capture." When royalties are received from Digital Service Providers, they are placed into the DeFi platform AAVE for a set period. During this time, the royalties earn interest, which we retain, while you keep 100% of the principal royalty amount. After this period, your earnings, beyond a minimal locked amount, are fully available for withdrawal. Unlike others who claim to be free, we truly are.',
  },
  {
    q: "How do I transfer my catalog from another distributor?",
    a: "Transferring your catalog to FM Digital Official is simple. You'll need a few key pieces of information:",
    list: [
      "The UPC and ISRC (to help DSPs identify your existing release)",
      "Release title and track title(s)",
      "Artist(s) name(s)",
      "The original release date",
      "The exact same audio and cover art files from the previous release.",
    ],
  },
  {
    q: "Are there any fees, and do I keep all my royalties?",
    a: "There are no upfront fees, but we offer two plans for music distribution:",
    list: [
      "Freemium Plan: You keep 70% of your royalties, with FM Digital Official retaining 30%.",
      "Premium Plan: You keep 100% of your royalties, ensuring you receive every cent of your earnings.",
    ],
    after: "FM Digital Official provides flexible options to suit your needs, whether you're just starting out or looking to maximize your revenue.",
  },
  {
    q: "Can I update or change my release after it's been distributed?",
    a: "Yes, you can update your release after distribution. However, certain changes, like updating metadata or replacing audio files, may require additional processing time. Contact our support team for specific changes.",
  },
];

// Checkout page config, keyed by URL slug (/ads/plan/<slug>)
export const PLAN_SLUGS = { starter: "starter", artist_pro: "artist-pro", label: "label" };

export const PLAN_INFO = {
  starter: {
    planKey: "starter",
    name: "Starter",
    price: { amount: "539", per: " / release" },
    note: "incl. GST · Annual special offer — lock in your price now",
    accent: "#4ade80",
    accentRgb: "74,222,128",
    features: [
      "1 song distribution",
      "190+ DSPs & stores",
      "Basic metadata tools",
      "Free UPC & ISRC code",
      "Standard delivery time",
      "Revenue: 70% / 30%",
      "Publishing rights & revenue",
      "24/7 Support panel",
    ],
    amount: 53900,
    cta: "pay",
  },
  "artist-pro": {
    planKey: "artist_pro",
    name: "Artist Pro",
    price: { amount: "2,399", per: " / year" },
    note: "incl. GST · Unlimited releases, zero hidden fees",
    accent: "#8b5cf6",
    accentRgb: "139,92,246",
    features: [
      "Unlimited releases",
      "190+ DSPs & stores",
      "Advanced metadata tools",
      "Monthly royalty report",
      "Free UPC & ISRC code",
      "Priority delivery",
      "Revenue: 100% to Artist",
      "Publishing rights & revenue",
      "24/7 Support panel",
      "Referral earnings",
    ],
    amount: 239900,
    cta: "pay",
  },
  label: {
    planKey: "label",
    name: "Label",
    price: { amount: "Custom", per: "" },
    note: "Tailored to your roster & volume",
    accent: "#f59e0b",
    accentRgb: "245,158,11",
    features: [
      "Everything in Artist Pro",
      "Manage multiple artists & labels",
      "Bulk release tools",
      "Unlock new revenue streams",
      "Dedicated account manager",
      "Custom royalty splits",
      "White-label dashboard",
    ],
    cta: "whatsapp",
  },
};

export const API_BASE = process.env.REACT_APP_API_BASE || "";
